export class GeneralOverlay extends HTMLElement {
    constructor() {
        super();
        this.bindEvents();
    }

    bindEvents() {
        this.addEventListener("click", this.onOverlyClick.bind(this))
    }

    applyOverlay(targetElement: any) {
        document.querySelector("general-overlay")?.classList.remove("hidden");
        targetElement?.classList.add("highest-z-index");
        document.body.style.overflow = 'hidden';
    }

    removeOverlay(targetElement: any) {
        document.querySelector("general-overlay")?.classList.add("hidden");
        targetElement?.classList.remove("highest-z-index");
        document.body.style.overflow = '';
    }

    onOverlyClick(event: Event) {
        event.stopPropagation();
        event.preventDefault();

        const previewCartCloseIcon = document.querySelector("preview-cart preview-cart-close") as HTMLElement;
        previewCartCloseIcon?.click();

        const mobileMegaMenuCloseIcon = document.querySelector('header-wrapper .icon-menu-mobile .close') as HTMLElement;
        mobileMegaMenuCloseIcon?.click();

        const facetsDrawerCloseIcon = document.querySelector("facet-mobile-drawer .collection__facets-draw-heading .close") as HTMLElement;
        facetsDrawerCloseIcon?.click();
    }
}

customElements.define("general-overlay", GeneralOverlay);

